export const SITE_URL = "https://maisonprincess.org";

export const STUDIO = {
  name: "MAISON PRINCESS",
  owner: "Aliona Birsan",
  email: "info@maisonprincess.de",
  phone: "0176 32532061",
  phoneHref: "tel:+4917632532061",
  street: "Darmstädter Straße 193",
  city: "64625 Bensheim",
  mapsUrl:
    "https://www.google.com/maps/search/?api=1&query=Darmst%C3%A4dter%20Stra%C3%9Fe%20193%2C%2064625%20Bensheim",
};

export const SUBJECT = "Terminanfrage – Maison Princess";

export const TREATMENTS = [
  {
    id: "fachfusspflege",
    numeral: "I",
    title: "Fachfußpflege",
    text: "Professionelle Fußpflege für gesunde und gepflegte Füße. Spezialisierte Pflege bei diabetischen Füßen sowie individuelle Beratung und Behandlung entsprechend dem jeweiligen Bedarf.",
    points: [
      "Fachgerechte Pflege für gesunde und problematische Füße",
      "Spezialisierte Pflege bei diabetischen Füßen",
      "Individuelle Beratung für deine Fußgesundheit",
    ],
    img: "/img/fachfusspflege-studio.jpg",
    alt: "Aliona Birsan, Fachfußpflegerin bei Maison Princess, im Studio",
    pos: "50% 12%",
  },
  {
    id: "fussreflexzonenmassage",
    numeral: "II",
    title: "Fußreflexzonenmassage",
    text: "Eine wohltuende Massage zur Entspannung und für ein angenehmes Körpergefühl.",
    points: ["Zeit zum Abschalten", "Sanft, ruhig und wohltuend"],
    img: "/img/reflex.jpg",
    alt: "Hände massieren sanft einen Fuß in ruhiger Spa-Atmosphäre",
  },
  {
    id: "extras",
    numeral: "III",
    title: "Extras nach Absprache",
    text: "Zusätzliche Behandlungen wie das Bearbeiten eingewachsener Nägel sowie weitere Anliegen – individuell und in Absprache mit deiner Fußpflegerin.",
    points: ["Eingewachsene Nägel", "Druckstellen & Hornhaut", "Weitere Anliegen nach Absprache"],
    img: "/img/extras.jpg",
    alt: "Professionelle Fußbehandlung mit Handschuhen auf einem Behandlungsstuhl",
  },
];
